export const dateBySlash = 'DD/MM/YYYY';
export const MM_DD_YYYY = "MM/DD/YYYY";
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const FLATPICKER_FORMAT = "d/m/y";
export const FLATPICKER_FORMAT_ALT = "d/m/Y";
export const LOG_DATE_FORMAT = "D MMMM, HH:mm"